import { CompaniesModel } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

class Company extends RequestCreator<CompaniesModel> {}

const api = new Company('/ipad/companies');
export default api;
